import React, { useEffect, useLayoutEffect, useState } from "react";
import OtpInput from "react-otp-input";
import data from "../../assets/images/data.svg";
import validity from "../../assets/images/validity.svg";
import speed from "../../assets/images/speed.svg";
import paymentsucess from "../../assets/images/paymentsucess.svg";
import { useFormik } from "formik";
import { userSchema } from "./validations";
import styles from "./styles/style.module.css";
import comLogo from "../../assets/images/comLogo.svg";
import PhoneInput, {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { getbundles, getCountries } from "../vfsuk/api";
import DatePicker from "react-datepicker";
import {
  addToCart,
  createOrder,
  createUser,
  getCart,
  getFilter,
  otpVeriFy,
  purchaseOrder,
  sendOtp,
  stripePaymentIntent,
} from "./api";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useAuth from "../../lib/useAuth";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripeForm from "./StripeForm";
import Pagination from "../pagination";
import axios from "axios";

function Checkout() {
  const { id } = useParams();
  const { isAuthenticated, loginUser, logout } = useAuth();
  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const countryId: any = queryParams.get("country");
console.log(countryId,"countryId");

  const [otpShow, setOtpShow] = useState({
    otp: false,
    otpId: "",
    otpVal: "",
    params: "",
    phoneNumber: "",
    email: "",
  });
  const [userPopup, setUserPopup] = useState(false);
  const [cartUpdate, setCartUpdate] = useState(false);
  const [isPhoneNoVerified, setPhoneNoVerified] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [countriesData, setCountriesData] = useState<any>({
    items: [],
    count: 0,
  });
  const [token, setToken] = useState("");
  const [cartData, setCartData] = useState<any>("");
  const [filterData, setFilterData] = useState<any>("");
  const [filterValues, setFilterValues] = useState<any>({
    validityDays: "",
    dataAmount: "",
  });
  const [bundlesData, setBundlesData] = useState<any>({ items: [], count: 0 });
  const [bundlesData2, setBundlesData2] = useState<any>({ items: []});
  const [pagination, setPagination] = useState<any>({
    currentPage: 1,
    parPageRecords: 5,
  });
  const [show, setShow] = useState<boolean>(false);
  const [paymentDetails, setPaymentDetails] = useState<any>({
    clientSecret: "",
    paymentId: "",
    setupIntent: "",
    currency: "",
    label: "Total",
    amount: 0,
  });

  const [paymentMethod, setPaymentMethod] = useState(1);
  const [bundleIds, setBundleIds] = useState<any>([]);
  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLIC_KEY as string
  );
  const [paymentSuccess, setPaymentSuccess] = useState<boolean>(false);
const BaseUrl = process.env.REACT_APP_API_URL

  useLayoutEffect(() => {
    formik.setFieldValue("travellingCountry", countryId);
    getCart(id as string)
      .then((res: any) => {
        if (!res?.data) navigate("/");
        // setFilterValues({
        //   validityDays: res?.data?.items[0]?.duration,
        //   dataAmount: res?.data?.items[0]?.dataAmount,
        // });
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  const fetchPlans = async () => {
    try {
      const query: any = {
        page: 1,
        limit: 5,
        countryName: countriesData?.items?.find((country: any) => country._id === countryId)?.name || "",
        countryId: countryId,
        isCountry: true,
      };
  
      // Add filters only if they exist
      if (filterValues?.validityDays) query.duration = filterValues.validityDays;
      if (filterValues?.dataAmount) query.dataAmount = filterValues.dataAmount;
  
      const response = await axios.get(BaseUrl + "/vfsPhillip/esim-plan", {
        params: query,
        headers: {
          Partnerwebsiteid: "6798f6584c9989f41ae281d"
        }
      });
      const sortedItems = response?.data?.data?.sort((a: any, b: any) => a.dataAmount - b.dataAmount);
      setBundlesData2({ items: sortedItems});
    } catch (err) {
      console.error(err, "error"); // Handle errors
    }
  };
  

  useEffect(() => {
    if (countryId && countriesData?.items?.length > 0) {
      fetchPlans();
    }
  }, [countryId, countriesData ,filterValues]);


  const formik: any = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      handsetModel: "",
      travellingCountry: "",
      travellingDate: "",
      isEmailVerified,
      isPhoneNoVerified:false,
    },

    validationSchema: userSchema,

    onSubmit: async (values, { setFieldError }) => {
      console.log(values,"values");
      // if (
      //   !isPossiblePhoneNumber(values.phoneNumber) ||
      //   !isValidPhoneNumber(values.phoneNumber)
      // ) {
      //   setFieldError("phoneNumber", "Invalid phone number");
      //   return;
      // }

      const parsedNumber = parsePhoneNumber(values.phoneNumber);

      let payload: any = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        handsetModel: values.handsetModel,
        countryCode: `+${parsedNumber?.countryCallingCode as string}`,
        phoneNumber: parsedNumber?.nationalNumber as string,
        isEmailVerified,
        isPhoneNoVerified,
        deviceType: 1,
        destinationTravellingCountryId: values.travellingCountry,
        destinationDate: values.travellingDate,
      };

      if (!payload.isPhoneNoVerified && !payload.isEmailVerified) {
        formik.errors.phoneNumber = "Phone is not verified!";
        formik.errors.email = "Email is not verified!";
        return null;
      }

      // if (!payload.isPhoneNoVerified) {
      //   formik.errors.phoneNumber = "Phone is not verified!";
      //   return null;
      // }

      if (!payload.isEmailVerified) {
        formik.errors.email = "Email is not verified!";
        return null;
      }

      createUser(payload)
        .then((res: any) => {
          if (res?.statusCode === 400)
            return toast.error(res?.message || "Something went wrong.");
          setToken(res.accessToken);
          loginUser(res.accessToken);
          return toast.success(res?.message || "User Create successfully");
        })
        .catch((error) => {
          return toast.error(error?.data?.message || "Something went wrong.");
        });
    },
  });

  useEffect(() => {
    formik.setFieldValue("travellingCountry", countryId);
    getCountries({
      page: 1,
      limit: 300,
      isVFS: true,
    },"6798f6584c9989f41ae281d")
      .then((res: any) => {
        setCountriesData({
          items: res?.data?.countries,
          count: res?.data?.count,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    getFilter({ search: "Europe" },"6798f6584c9989f41ae281d")
      .then((res: any) => {
        setFilterData(res?.data[0]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  //wdwdwdw
  useEffect(() => {
    if (token)
      createOrder({ cartId: id })
        .then((res: any) => {
          if (res?.totalAmount === 0) {
            purchaseOrder({ orderId: res?.orderId, status: 0 },"6798f6584c9989f41ae281d")
              .then((res: any) => {
                setShow(false);
                setUserPopup(false);
                setPaymentSuccess(true);
              })
              .catch((error: any) => {
                // setShow(true);
                toast.error(error?.data?.message || "Something went wrong!");
              });
          } else {
            stripePaymentIntent({ orderId: res?.orderId, isVFS: true })
              .then((res: any) => {
                setPaymentDetails({
                  clientSecret: res.data.paymentIntentSecretKey,
                  paymentId: res.data.paymentId,
                  setupIntent: res.data.setupIntent,
                  currency: res.data.currency.toLowerCase(),
                  label: "Total",
                  amount: res.data.amount,
                });
                setShow(true);
                setUserPopup(false);
              })
              .catch((error: any) => {
                // setShow(true);
                toast.error(error?.data?.message || "Something went wrong!");
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
  }, [isAuthenticated, token]);

  useEffect(() => {
    getCart(id as string)
      .then((res: any) => {
        if (!res?.data) navigate("/");
        const filter = res?.data?.items?.map((item: any) => item.bundleId);
        setBundleIds([...filter]);
        setCartData(res?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [cartUpdate]);
  const planNames = cartData?.items?.map((item: any) => item?.name).filter(Boolean);
  // useEffect(() => {
  //   const query: any = {
  //     page: pagination?.currentPage,
  //     limit: pagination?.parPageRecords,
  //     // countryName:"Philippines",
  //   };

  //   if (countryId) query.countryId = countryId;

  //   if (filterValues?.validityDays) query.duration = filterValues?.validityDays;
  //   if (filterValues?.dataAmount) query.dataAmount = filterValues?.dataAmount;
  //   if (bundleIds?.length > 0) query.bundleIds = bundleIds;
  //   if (planNames?.length > 0) {
  //     query.name = planNames.length === 1 ? planNames[0] : planNames;
  //   }
    
  //   getbundles(query)
  //     .then((res: any) => {
  //       if (Array.isArray(res?.data)) {
  //         setBundlesData({ items: res.data, count: res.count || 0 });
  //         setBundlesData2({ items: res.data, count: res.count || 0 });
         
  //       } else {
         
  //         setBundlesData({ items: [], count: 0 });
  //         setBundlesData2({ items: [], count: 0 });
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }, [pagination, filterValues, countryId, bundleIds,]);

  const handleSendOtpCode = (params: string) => {
    const otpPayload: any = {
      type: 4,
    };

    if (params == "phoneNumber") {
      const phoneNumber: any = formik.values.phoneNumber;
      const parsedNumber = parsePhoneNumber(phoneNumber);

      if (parsedNumber?.nationalNumber && parsedNumber?.countryCallingCode) {
        otpPayload.phoneNumber = parsedNumber.nationalNumber as string;
        otpPayload.countryCode = `+${parsedNumber.countryCallingCode as string
          }`;
      }
    } else {
      const email: any = formik.values.email;
      otpPayload.email = email;
    }

    toast.promise(sendOtp(otpPayload), {
      pending: {
        render() {
          return "Trying to send otp";
        },
      },
      success: {
        render({ data }) {
          setOtpShow((pre: any) => ({
            ...pre,
            otpId: data?.data?.otpId,
            otp: true,
            otpVal: "",
            params,
          }));
          return "OTP sent successfully";
        },
      },
      error: {
        render({ data }: any) {
          return data.data.message;
        },
      },
    });
  };

  const handleVerifyOtp = () => {
    if (!otpShow?.otpVal) return toast.error("Please enter vaild OTP");
    const payload = {
      otp: otpShow?.otpVal,
      type: 4,
      otpId: otpShow?.otpId,
    };

    toast.promise(otpVeriFy(payload), {
      pending: {
        render() {
          return "Trying to verify otp";
        },
      },
      success: {
        render({ data }) {
          let otpData: any;
          if (otpShow?.params === "email") {
            setIsEmailVerified(true);
            otpData = { email: formik.values.email };

            setIsEmailVerified(true);
          } else {
            setPhoneNoVerified(true);
            otpData = { phoneNumber: formik.values.phoneNumber };
            setPhoneNoVerified(true);
          }
          setOtpShow((pre: any) => ({
            ...pre,
            otpId: data?.data?.otpId,
            otp: false,
            otpVal: "",
            ...otpData,
          }));
          return "OTP verify successfully";
        },
      },
      error: {
        render({ data }: any) {
          return data.data.message;
        },
      },
    });
  };

  const handelAddToCart = (params: any) => {
    toast.promise(addToCart(id as string, params), {
      pending: {
        render() {
          return params?.type === 1
            ? "Trying to add item"
            : "Trying to remove item";
        },
      },
      success: {
        render({ data }: any) {
          setCartUpdate(!cartUpdate);
          return data?.message;
        },
      },
      error: {
        render({ data }: any) {
          return data.data.message || "Something wents wrong!";
        },
      },
    });
  };

  const options = {
    clientSecret: paymentDetails?.clientSecret,
  };

  const handlePageChange = (page: number) => {
    setPagination((pre: any) => ({ ...pre, currentPage: page }));
  };

  return (
    <>
      <div className="vfsukbaneer">
        <span className="comlogo">
          <img src={comLogo} alt="" />
        </span>
        <div className="container">
          <h3>Almost There! </h3>
          <p>
            Fill out the form below to unlock your free data and stay connected
            on your
            <br /> travels. It's quick and easy!
          </p>
        </div>
      </div>
      <div className="checkoutProcess">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="leftchatProces">
                <h3>Upgrade Your Plan </h3>
                <div className="plansList">
                  <h5>
                    SIM card validity
                    {(filterValues?.validityDays ||
                      filterValues?.dataAmount) && (
                        <span
                          style={{
                            float: "right",
                            color: "red",
                            cursor: "pointer",
                            paddingRight: "10px",
                          }}
                          onClick={() =>
                            setFilterValues({
                              validityDays: "",
                              dataAmount: "",
                            })
                          }
                        >
                          Clear
                        </span>
                      )}
                  </h5>
                  <ul>
                    {filterData?.validityDays &&
                      filterData?.validityDays?.map((item: any) => (
                        <li
                          className={
                            filterValues?.validityDays === item ? "active" : ""
                          }
                          onClick={() =>
                            setFilterValues((pre: any) => ({
                              ...pre,
                              validityDays: item,
                            }))
                          }
                        >
                          <span>
                            {item}
                            {item == 1 ? " Day" : " Days"}
                          </span>
                        </li>
                      ))}
                  </ul>
                  <h5>Data package</h5>
                  <ul>
                    {filterData?.dataAmount &&
                      filterData?.dataAmount?.map((item: any) => (
                        <li
                          className={
                            filterValues?.dataAmount === item ? "active" : ""
                          }
                          onClick={() =>
                            setFilterValues((pre: any) => ({
                              ...pre,
                              dataAmount: item,
                            }))
                          }
                        >
                          <span>
                            {item == -1
                              ? "Unlimited"
                              : item / 1000 >= 1
                                ? item / 1000 + " GB"
                                : item / 1000 + " MB"}
                          </span>
                        </li>
                      ))}
                  </ul>
                  <div className="palnsDetails">
                    {cartData &&
                      cartData?.items?.map((item: any, index: number) => (
                        <div className="ukPlansOuter">
                          <div className="ukplanHead">
                            <div className="ukplanHeadleft">
                              <h4>{item?.name}</h4>
                            </div>
                            <div className="ukplanHeadright">
                              <span>
                                {item?.priceSymbol} {item?.price}
                              </span>
                            </div>
                          </div>
                          <div className="newpatren">
                            <div className="row">
                              <div className="col-md-4">
                                <div className="planinner">
                                  <span>
                                    <img src={data} alt="" />
                                    Data
                                  </span>
                                  <h4>
  {(() => {
    console.log("Data Amount:", item?.dataAmount);
    return item?.dataAmount === -1
      ? "Unlimited"
      : item?.dataAmount / 1000 < 1
      ? item?.dataAmount?.toFixed(3) + " MB"
      : item?.dataAmount / 1000 + " GB";
  })()}
</h4>

                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="planinner">
                                  <span>
                                    <img src={validity} alt="" />
                                    Validity
                                  </span>
                                  <h4>
                                    {item?.duration <= 1
                                      ? item?.duration + " Day"
                                      : item?.duration + " Days"}
                                  </h4>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="planinner">
                                  <span>
                                    <img src={speed} alt="" />
                                    Speed
                                  </span>
                                  <h4>
                                    {item?.speed && item.speed.length > 0
                                      ? item.speed.slice(-1)
                                      : "High Speed"}
                                  </h4>
                                </div>
                              </div>
                            </div>
                            <span
                              className={`added ${!item?.scratchType ? "" : "disabled"
                                }`}
                              onClick={(e) => {
                                if (item?.scratchType) return; // Prevent click if disabled
                                e.preventDefault();
                                handelAddToCart({
                                  items: [
                                    {
                                      bundleId: item?.bundleId,
                                      quantity: 1,
                                      price: Number(item?.price),
                                    },
                                  ],
                                  type: 2,
                                });
                              }}
                            >
                              {!item?.scratchType ? "Remove" : " Added"}
                            </span>
                          </div>
                        </div>
                      ))}

                    {true ? (
                      bundlesData2?.items?.map((item: any, index: number) => (
                        <div className="ukPlansOuter" key={index}>
                          <div className="ukplanHead">
                            <div className="ukplanHeadleft">
                              <h4>{item?.name}</h4>
                              {/* <h5>Country</h5> */}
                            </div>
                            <div className="ukplanHeadright">
                              <span>
                                {item?.priceSymbol} {item?.price}
                              </span>
                            </div>
                          </div>
                          <div className="newpatren">
                            <div className="row">
                              <div className="col-md-4">
                                <div className="planinner">
                                  <span>
                                    <img src={data} alt="" />
                                    Data
                                  </span>
                                  <h4>
                                    {item?.dataAmount == -1
                                      ? "Unlimited"
                                      : item?.dataAmount / 1000 < 1
                                        ? item?.dataAmount?.toFixed(3) + " MB"
                                        : item?.dataAmount / 1000 + " GB"}
                                  </h4>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="planinner">
                                  <span>
                                    <img src={validity} alt="" />
                                    Validity
                                  </span>
                                  <h4>
                                    {item?.duration <= 1
                                      ? item?.duration + " Day"
                                      : item?.duration + " Days"}
                                  </h4>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="planinner">
                                  <span>
                                    <img src={speed} alt="" />
                                    Speed
                                  </span>
                                  <h4>
                                    {item?.speed && item.speed.length > 0
                                      ? item.speed.slice(-1)
                                      : "High Speed"}
                                  </h4>
                                </div>
                              </div>
                            </div>
                            <a
                              onClick={(e) => {
                                e.preventDefault();
                                handelAddToCart({
                                  items: [
                                    {
                                      bundleId: item?._id,
                                      quantity: 1,
                                      price: Number(item?.price),
                                    },
                                  ],
                                  type: 1,
                                });
                              }}
                            >
                              Add to Cart
                            </a>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="ukPlansOuter">
                        <div className="newpatren">
                          <div className="row">
                            <div className="col-md-7">
                              <h5>Sorry Plan not found.</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* {bundlesData?.items?.length > 0 && (
                      <Pagination
                        count={bundlesData?.count} // You can replace this with the actual count received from the API
                        handlePageChange={handlePageChange}
                        currentPage={pagination?.currentPage}
                        itemsPerPage={pagination?.parPageRecords}
                      />
                    )} */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="rightchatProces">
                <div className="rightCheckout">
                  <h3>Secure Checkout</h3>
                  <div className="planSummary">
                    <h4>Payment Summary</h4>
                    <ul>
                      {cartData &&
                        cartData?.items?.map((item: any, index: number) => (
                          <li>
                            <div>
                              {item?.name}
                              {" ("}
                              {item?.dataAmount == -1
                                ? "Unlimited"
                                : item?.dataAmount / 1000 < 1
                                  ? item?.dataAmount?.toFixed(3) + " MB"
                                  : item?.dataAmount / 1000 + " GB"}
                              /
                              {item?.duration <= 1
                                ? item?.duration + " Day"
                                : item?.duration + " Days"}
                              {")"}
                              <label>
                                <i>
                                  {item?.scratchType
                                    ? `Already added in Cart`
                                    : null}
                                </i>
                              </label>
                            </div>

                            <span>
                              {item?.scratchType
                                ? ` ${item?.priceSymbol}  0.00`
                                : `${item?.priceSymbol || ""}  ${item?.price}`}
                            </span>
                          </li>
                        ))}
                      {/* <li>
                        Subtotal{" "}
                        <span>
                          {" "}
                          {cartData?.priceSymbol} {cartData?.subTotal}
                        </span>
                      </li> */}
                      {/* <li>
                        Discount{" "}
                        <span>
                          {cartData?.priceSymbol} {cartData?.discount}
                        </span>
                      </li> */}
                      <li>
                        Total{" "}
                        <span>
                          {cartData?.priceSymbol} {cartData?.totalAmount}
                        </span>
                      </li>
                    </ul>
                    <button
                      onClick={() => {
                        token ? setShow(true) : setUserPopup(true);
                      }}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {userPopup && (
        <div
          className="modal fade show"
          id="personalDetails"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setUserPopup(false)}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="detailsPersoanl">
                  <h3>Redeem your 2GB Data</h3>
                  <p>
                    Fill in your details and start enjoying seamless
                    connectivity!
                  </p>
                  <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="formGroup">
                          <label>First Name*</label>
                          <input
                            type="text"
                            name="firstName"
                            placeholder="Enter your First Name"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.firstName}
                          />
                          {formik.touched.firstName &&
                            formik.errors.firstName && (
                              <div className={styles.error}>
                                {formik.errors.firstName}
                              </div>
                            )}
                        </div>

                      </div>
                      <div className="col-md-6">
                        <div className="formGroup">
                          <label>Last Name*</label>
                          <input
                            type="text"
                            name="lastName"
                            placeholder="Enter your Last Name"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.lastName}
                          />
                          {formik.touched.lastName &&
                            formik.errors.lastName && (
                              <div className={styles.error}>
                                {formik.errors.lastName}
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="formGroup">
                          <label>Phone Number</label>
                          <PhoneInput
                            placeholder="Enter your Phone Number"
                            onChange={(value) => {
                              formik.setFieldValue("phoneNumber", value !== undefined ? value : "");
                              if (otpShow?.phoneNumber === value) {
                                setPhoneNoVerified(true);
                              } else {
                                setPhoneNoVerified(false);
                              }
                            }}
                            value={formik.values.phoneNumber}
                          />
                          {/* <span className="verifylnk"
                            onClick={async () => {
                              // Mark the phone number field as touched to display validation errors
                              formik.setTouched({ phoneNumber: true });

                              // Trigger validation for the entire form
                              const errors = await formik.validateForm();

                              // Check if phoneNumber has validation errors
                              if (errors.phoneNumber) {
                                return;
                              }

                              if (isPhoneNoVerified) return false;

                              handleSendOtpCode("phoneNumber");
                            }}
                          >
                            {isPhoneNoVerified ? "Verified" : "Verify"}
                          </span> */}
                          {/* {formik.touched.phoneNumber &&
                            formik.errors.phoneNumber && (
                              <div className={styles.error}>
                                {formik.errors.phoneNumber}
                              </div>
                            )} */}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="formGroup">
                          <label>Email*</label>
                          <input
                            type="text"
                            name="email"
                            placeholder="Enter your Email"
                            onChange={(e: any) => {
                              formik.setFieldValue("email", e.target.value);

                              if (otpShow?.email === e.target.value) {
                                setIsEmailVerified(true);
                              } else {
                                setIsEmailVerified(false);
                              }

                              // formik.handleChange
                            }}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                          // readOnly={!emailVerified}
                          />
                          <span className="verifylnk"
                            onClick={async () => {
                              // Mark the phone number field as touched to display validation errors
                              formik.setTouched({ email: true });

                              // Trigger validation for the entire form
                              const errors = await formik.validateForm();

                              // Check if phoneNumber has validation errors
                              if (errors.email) {
                                return;
                              }
                              if (isEmailVerified) return false;
                              handleSendOtpCode("email");
                            }}
                          >

                            {isEmailVerified ? "Verified" : "Verify"}
                          </span>
                          {formik.touched.email && formik.errors.email && (
                            <div className={styles.error}>
                              {formik.errors.email}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="formGroup">
                          <label>Handset Model Name</label>
                          <input
                            type="text"
                            name="handsetModel"
                            placeholder="Enter Handset Model Name"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.handsetModel}
                          />
                          {formik.touched.handsetModel &&
                            formik.errors.handsetModel && (
                              <div className={styles.error}>
                                {formik.errors.handsetModel}
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="formGroup">
                          <label>Traveling Country*</label>
                          <select
                            name="travellingCountry"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.travellingCountry}
                            disabled
                          >
                            <option value="">Select Country</option>
                            {countriesData?.items &&
                              countriesData?.items?.map((list: any) => (
                                <option value={list?._id}>{list?.name}</option>
                              ))}
                          </select>
                          {formik.touched.travellingCountry &&
                            formik.errors.travellingCountry && (
                              <div className={styles.error}>
                                {formik.errors.travellingCountry}
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="formGroup">
                          <label>Date*</label>
                          <DatePicker
                            selected={
                              formik.values.travellingDate
                                ? new Date(formik.values.travellingDate)
                                : null
                            } // Ensure it's a Date object
                            onChange={(date) =>
                              formik.setFieldValue("travellingDate", date)
                            } // Set the date
                            name="travellingDate"
                            placeholderText="Select Travelling Date"
                            onBlur={formik.handleBlur}
                            dateFormat="dd-M-yyyy" // Optional
                            value={formik.values.travellingDate}
                          />
                          {formik.touched.travellingDate &&
                            formik.errors.travellingDate && (
                              <div className={styles.error}>
                                {formik.errors.travellingDate}
                              </div>
                            )}
                        </div>
                      </div>
                      {(
                        formik.errors.email === "Email is not verified!") && (
                          <div className="col-md-12">
                            <div className="mymessage">
                              <h6>
                                Verify your phone number and email to continue and
                                unlock your 2GB data.
                              </h6>
                            </div>
                          </div>
                        )}

                      <div className="col-md-12">
                        <div className="submtbnt">
                          <button type="submit">Continue</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* opt modal */}
      {otpShow?.otp && (
        <div
          className="modal fade show"
          id="OTPverify"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                {/* <h5 className="modal-title" id="exampleModalLabel">Modal title</h5> */}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setOtpShow((pre: any) => ({ ...pre, otp: false }));
                  }}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="otpVerfiy">
                  <h4>
                    Verify{" "}
                    {otpShow?.params === "email" ? "Email" : "Phone Number"}
                  </h4>
                  <p>
                    Ensure the Security of Your Account by Completing the{" "}
                    {otpShow?.params === "email" ? "Email" : "Phone Number"}{" "}
                    Verification Process
                  </p>
                  <OtpInput
                    value={otpShow?.otpVal}
                    onChange={(otp) =>
                      setOtpShow((pre: any) => ({ ...pre, otpVal: otp }))
                    }
                    numInputs={5}
                    // renderSeparator={<span>-</span>}
                    renderInput={(props) => <input {...props} />}
                  />

                  <div className="verifyBtn">
                    <button type="submit" onClick={handleVerifyOtp}>
                      Verify OTP
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {show && (
        <div
          className="modal fade show"
          id="OTPverify"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                {/* <h5 className="modal-title" id="exampleModalLabel">Modal title</h5> */}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setShow(false)}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="cardChange">
                  <h4>Card Details</h4>

                  {/* <div className="paymntmode">
                    <ul> */}
                  {/* <li>
                        <img src={payone} alt="" />
                        Apple Pay
                      </li> */}
                  {/* <li onClick={() => setPaymentMethod(1)}>
                        <img src={paytwo} alt="" />
                        Credit / Debit Card{" "}
                        {paymentMethod > 0 && <span>Selected</span>}
                      </li>
                    </ul>
                  </div> */}
                  {paymentMethod > 0 && (
                    <Elements stripe={stripePromise} options={options}>
                      <StripeForm
                        setPaymentSuccess={setPaymentSuccess}
                        setShow={setShow}
                        clientSecret={paymentDetails?.clientSecret}
                      />
                    </Elements>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {paymentSuccess && (
        <div
          className="modal fade show"
          id="OTPverify"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    logout();
                    setToken("");
                    navigate(`/`);
                    setPaymentSuccess(false);
                  }}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="otpVerfiy payemntSucess">
                  <img src={paymentsucess} alt="" />
                  <h4>Payment Successful!</h4>
                  <p>
                    Thank you for making a purchase! Your order is being
                    processed immediately. We will notify you via email when
                    your order is ready to be dispatched. Thank you for your
                    patience!
                  </p>

                  {/* <div className="verifyBtn">
                    <button type="submit">Proceed to Activate</button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Checkout;
